import {
  Button,
  CircularProgress,
  Container,
  Heading,
  HStack,
  Stack,
  VStack,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { Beforeunload, useBeforeunload } from "react-beforeunload";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import Layout from "../../../components/student/Layout/layout";
import ExamHint from "../../../containers/student/exams/exam-hint";
import ExamQuestions from "../../../containers/student/exams/exam-questions";
import ExamSolvedQuestions from "../../../containers/student/exams/exam-solved-questions";
import Timer from "../../../containers/student/exams/timer";
import ExamAnswersLoading from "../../../containers/student/models/exam-answers-loading";
import IndexList from "../../../containers/student/studyWithEnough/IndexList";
import {
  closeExamAnswersLoading,
  openExamAnswersLoading,
  openExamHintkModel,
} from "../../../modules/admin-modules/models/Actions";
import {
  getChapterExamByIdRequest,
  sendChapterExamAnswersRequest,
} from "../../../modules/students-modules/exams/Actions";

const StudyWithEnoughSolveExam = () => {
  const [examQuestions, setExamQuestions] = useState([]);
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const parsed = searchParams.get("name");
  const [loading, setLoading] = useState(false);

  const { id: examId } = useParams();

  const examQuestionsData = useSelector(
    (state) => state.chapterExams.chapterExamDetails
  );
  const studentExamQuestions = useSelector(
    (state) => state.studentExams.chapterExamDetails
  );
  const isLoading = useSelector((state) => state.chapterExams.isLoading);
  const exam = useSelector((state) => state.chapterExams.chapterExamDetails);

  const [answers, setAnswers] = useState([]);
  const [selectedQuestionIdx, setSelectedQuestionIdx] = useState(0);
  const videoData = exam?.[selectedQuestionIdx]?.url?.split("/");
  const splitLength = exam?.[selectedQuestionIdx]?.url?.split("/")?.length;
  const videoId = videoData?.[splitLength - 1];

  useBeforeunload((event) => {
    if (Object.keys(answers)?.length != examQuestions?.length) {
      event.preventDefault();
      return "you will lose your data";
    }
  });
  useEffect(() => {
    dispatch(getChapterExamByIdRequest(examId));
  }, [examId, window.location.pathname]);

  useEffect(() => {
    setExamQuestions(examQuestionsData);
  }, [studentExamQuestions, examQuestionsData]);

  const handelNextQuestion = () => {
    if (selectedQuestionIdx < 0)
      setSelectedQuestionIdx(examQuestions?.length - 1);
    else if (selectedQuestionIdx >= examQuestions?.length - 1)
      setSelectedQuestionIdx(0);
    else setSelectedQuestionIdx((s) => s + 1);
  };
  const handelPrevQuestion = () => {
    if (selectedQuestionIdx > examQuestions?.length - 1)
      setSelectedQuestionIdx(0);
    if (selectedQuestionIdx <= 0)
      setSelectedQuestionIdx(examQuestions?.length - 1);
    else setSelectedQuestionIdx((s) => s - 1);
  };

  const handelSendAnswers = async () => {
    const action = () => {
      dispatch(closeExamAnswersLoading());
      setAnswers([]);
      dispatch(getChapterExamByIdRequest(examId));
    };
    const currentQuestion = examQuestions[selectedQuestionIdx];
    const currentAnswer = answers[selectedQuestionIdx];
    const isEssay = currentQuestion?.type == 1;

    let formData = {
      exam_id: examId,
      question_id: currentAnswer?.question_id,
      answer_id: currentAnswer?.answer_id,
    };
    if (
      currentAnswer?.short_answer != null &&
      currentAnswer?.short_answer !== ""
    ) {
      formData.short_answer = currentAnswer.short_answer;
    }

    const canSubmitMcq = Boolean(currentAnswer?.answer_id);
    const canSubmitEssay =
      typeof currentAnswer?.short_answer === "string" &&
      currentAnswer.short_answer.trim().length > 0;

    if (isEssay ? canSubmitEssay : canSubmitMcq) {
      dispatch(openExamAnswersLoading());
      dispatch(sendChapterExamAnswersRequest(formData, action));
    } else {
      toast.error(isEssay ? "اكتب إجابتك أولاً" : "Choose answer first");
    }
  };

  return (
    <Layout color="main_1" bg="white" isLoading={false}>
      <Beforeunload onBeforeunload={() => "You’ll lose your data!"} />

      <Container
        maxW="container.xl"
        h="100%"
        my="100px"
        mb="165px"
        w="100%"
        onSelect={(e) => e.preventDefault()}
        onMouseDown={(e) => e.preventDefault()}
      >
        <Stack
          alignItems="start"
          gap="30px"
          flexDirection={{ base: "column", md: "row" }}
        >
          <IndexList
            examQuestions={examQuestions}
            setSelectedQuestionIdx={setSelectedQuestionIdx}
            selectedQuestionIdx={selectedQuestionIdx}
          />
          <VStack spacing={"70px"} h="100%" w={{ base: "100%", md: "70%" }}>
            <Heading
              as="h3"
              color="main_1"
              textAlign="center"
              w="100%"
              textTransform="capitalize"
            >
              {parsed}
            </Heading>
            {exam?.is_timed == 1 && (
              <Timer time={exam?.time} handelSendAnswers={handelSendAnswers} />
            )}
            {/* questions polts */}

            {examQuestions[selectedQuestionIdx]?.student_answers &&
              !isLoading && (
                <Button onClick={() => dispatch(openExamHintkModel())}>
                  Hint
                </Button>
              )}
            {/* questions */}
            {isLoading && <CircularProgress isIndeterminate />}
            {!examQuestions[selectedQuestionIdx]?.is_solved && !isLoading && (
              <ExamQuestions
                data={examQuestions[selectedQuestionIdx]}
                setAnswers={setAnswers}
                setLoading={setLoading}
                loading={loading}
                answers={answers}
                selectedQuestionIdx={selectedQuestionIdx}
              />
            )}
            {examQuestions[selectedQuestionIdx]?.is_solved && !isLoading && (
              <ExamSolvedQuestions
                data={examQuestions[selectedQuestionIdx]}
                correctionArr={examQuestions[selectedQuestionIdx]?.answers}
                selectedQuestionIdx={selectedQuestionIdx}
                studentAnswer={
                  examQuestions[selectedQuestionIdx]?.student_answers
                }
              />
            )}
            {/* submit */}
            <HStack mt="10px">
              {selectedQuestionIdx > 0 && (
                <Button onClick={handelPrevQuestion} bg="main_1" color="white">
                  {" "}
                  Prev Question
                </Button>
              )}

              <Button onClick={handelNextQuestion} bg="main_1" color="white">
                {" "}
                next Question
              </Button>
              <Button
                onClick={handelSendAnswers}
                bg="main_1"
                color="white"
                isDisabled={
                  examQuestions[selectedQuestionIdx]?.type == 1
                    ? !(
                        typeof answers[selectedQuestionIdx]?.short_answer ===
                          "string" &&
                        answers[selectedQuestionIdx]?.short_answer?.trim()
                          ?.length > 0
                      ) && !loading
                    : !answers[selectedQuestionIdx]?.answer_id && !loading
                }
              >
                {" "}
                Send answers
              </Button>
            </HStack>
          </VStack>
        </Stack>
      </Container>
      <ExamAnswersLoading />
      <ExamHint
        videoId={videoId}
        model_answer_image={
          examQuestions?.[selectedQuestionIdx]?.model_answer_image
        }
      />
    </Layout>
  );
};

export default StudyWithEnoughSolveExam;
